import React, { forwardRef, memo } from 'react'

const TicketRoundIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    {...props}>
    <path
      d="M15.6738 9.74487V32.7041"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.19434 26.3265C5.54748 26.3265 6.84521 25.789 7.80202 24.8322C8.75884 23.8753 9.29638 22.5776 9.29638 21.2245C9.29638 19.8713 8.75884 18.5736 7.80202 17.6168C6.84521 16.66 5.54748 16.1224 4.19434 16.1224V11.0204C4.19434 10.6821 4.32872 10.3577 4.56792 10.1185C4.80713 9.87926 5.13156 9.74487 5.46985 9.74487H36.0821C36.4204 9.74487 36.7448 9.87926 36.984 10.1185C37.2232 10.3577 37.3576 10.6821 37.3576 11.0204V16.1224C36.0045 16.1224 34.7067 16.66 33.7499 17.6168C32.7931 18.5736 32.2556 19.8713 32.2556 21.2245C32.2556 22.5776 32.7931 23.8753 33.7499 24.8322C34.7067 25.789 36.0045 26.3265 37.3576 26.3265V31.4285C37.3576 31.7668 37.2232 32.0913 36.984 32.3305C36.7448 32.5697 36.4204 32.7041 36.0821 32.7041H5.46985C5.13156 32.7041 4.80713 32.5697 4.56792 32.3305C4.32872 32.0913 4.19434 31.7668 4.19434 31.4285V26.3265Z"
      stroke="#78BE20"
      strokeWidth="3.22689"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

TicketRoundIcon.displayName = 'TicketRoundIcon'

export default memo(TicketRoundIcon)
